<template lang="pug">
        .pageCols-railItem
            h5.pageCols-railItemHeading {{title}}
            .pageCols-railItemBlock(v-for="discussion in discussions")
                p
                    a(:href="discussion.url" target="_blank") {{discussion.title}}
                ul.infoList.infoList--horizontal
                    li.infoList-item.ico-chat {{discussion.timePosted}} ago
                    li.infoList-item {{discussion.author}}
</template>

<script>
import api from '../apis/recentDiscussionsApi';

export default {
    name: 'DiscussionsWidget',
    props: {
        communityId: String,
        title: String
    },
    data() {
		return {
            discussions: []
        }
	},
    async created() {
        api.getRecentDiscussionsByCommunity(this.communityId)
            .then(resp => this.discussions = resp.data);
	}
}
</script>

<style scoped lang="scss">
</style>